// i18n
import translations from 'presentations/views/components/pages/FeatureListPage/i18n.json';
import { translateInComponent } from 'infras/i18n';

import { useContext } from 'react';
import { GetServerSideProps, GetStaticPropsContext } from 'next';

import MainDocument from 'presentations/views/components/MainDocument';
import FeatureListPage from 'presentations/views/components/pages/FeatureListPage';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { apiPath, featureListPath, webPath } from 'presentations/routes/path';
import { FeatureListItem } from 'presentations/api/schema/contents';
import { get } from 'infras/rest_client';

interface ServerProps {
  linkCanonical: string;
  features: FeatureListItem[];
}

// export async function getStaticProps({ locale }: GetStaticPropsContext) {
//   return {
//     props: {
//       linkCanonical: webPath(featureListPath(), locale),
//     },
//   };
// }
export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
}: any) => {
  // export async function getStaticProps({
  //   locale,
  //   params,
  // }: GetStaticPropsContext) {

  const result = await get(
    apiPath(`/v1/contents/features`, {
      locale,
      perPage: 100,
    }),
  );
  if (!result.isSuccess) {
    return { notFound: true };
  }
  if (!result.data) {
    return { notFound: true };
  }

  const features: FeatureListItem[] = result.data;
  const props: ServerProps = {
    features,
    linkCanonical: webPath(featureListPath(), locale),
  };
  return {
    props,
    // revalidate: 60 * 120
  };
};

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      linkCanonical={props.linkCanonical}
    >
      <FeatureListPage viewer={viewer} features={props.features} />
    </MainDocument>
  );
}
